import { Navigate } from "react-router-dom";
import { useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";
import useLocalStorage from "../hooks/useLocalStorage";
import { defineAbilityFor, getDefaultPathForRole } from "../casl/ability";

const PrivateRoute = ({ element, subject }: any) => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [company] = useLocalStorage("company");
  const [user] = useLocalStorage<any>("user");

  if (isAuthenticated) {
    if (company == null) {
      logout();
    }

    // If a required subject is specified, check CASL ability
    if (subject) {
      const ability = defineAbilityFor(user?.role);
      if (!ability.can("read", subject)) {
        const defaultPath = getDefaultPathForRole(user?.role);
        return <Navigate to={defaultPath} replace />;
      }
    }

    return element;
  } else {
    return <Navigate to='/login' replace />;
  }
};

export default PrivateRoute;
